import Store from 'app/store'
import CONSTANTS from 'app/constants'
import PubSub from 'core/pubsub'
import _ from 'underscore'
import subdomains from './subdomains.js'
import externaldomains from './externaldomains.js'

function checkStatus(to, from, next) {

	PubSub.$emit('unready')

	var subdomain = false
	var externaldomain = false

	if (process.env.VUE_APP_TYPE === 'externaldomain') {

		const host = window.location.hostname

		externaldomain = host

		if(externaldomains[externaldomain]) {

			to.params.name = externaldomains[externaldomain].name
			to.params.type = externaldomains[externaldomain].type

		} else {

			window.location.href = "https://geekgroup.app"

		}
		
	} else if (process.env.VUE_APP_TYPE === 'subdomain') {

		const host = window.location.hostname
		const parts = host.split('.')

		if (parts.length > 2) {
			subdomain = parts[0].toLowerCase()
		}

		if (process.env.VUE_APP_ENV === 'development') {

			subdomain = 'binder'

		}

		if(subdomains[subdomain]) {

			to.params.name = subdomains[subdomain].name
			to.params.type = subdomains[subdomain].type

		} else {

			window.location.href = "https://geekgroup.app"

		}

	}

	if (to.name !== from.name ||to.params.name !== from.params.name || to.params.type !== from.params.type) {

		PubSub.$emit('menu.close')
		PubSub.$emit('close.modals')
		PubSub.$emit('panel.close')
	
	}

	PubSub.$emit('switch.collapse')

	// logged in and requires guest
	if (Store.getters['session/loggedin'] && to.matched.some(record => record.meta.requireGuest)) {

		if(to.params.force) {

			next()

		} else {
				
			next({
				name: 'Collection',
				params: {
					type: CONSTANTS.TYPE.USERS,
					name: Store.getters['session'].name
				}
			})

		}

	// not logged in and requires login
	} else if (!Store.getters['session/loggedin'] && to.matched.some(record => record.meta.requireUser)) {

		next({
			name: 'Home'
		})

	} else {

		if (to.matched.some(record => record.meta.requireVerify)) {

			if (!_.contains([CONSTANTS.TYPE.USERS, CONSTANTS.TYPE.GROUPS, CONSTANTS.TYPE.BUDDIES], to.params.type)) {

				next({
					name: '404'
				})

			} else {

				// do we need to verify
				if (

					to.name !== 'Sync'

					&&

					(

						// post-sync, re-verify
						(
							from.name === 'Sync' && to.params.name === from.params.name && to.params.type === from.params.type
						) || 
						// change of context
						(
							(to.params.name !== from.params.name || to.params.type !== from.params.type) && 
							(Store.getters['context/type'] !== to.params.type || Store.getters['context/slug'] !== to.params.name)
						)
						||
						(
							!from.params.type
						)

					)

				) {

					PubSub.$emit('verifying')

					// check context has been verified
					Store.dispatch('verify', {
						type: to.params.type,
						name: to.params.name
					}).then(function(json) {

						PubSub.$emit('unready')
						PubSub.$emit('verified')

						if(!Store.getters['session/loggedin']) next({
							name: 'Home'
						})

						if(Store.getters['session/upgraded'] < 2) next({
							name: 'Home',
							params: {
								force: true
							}
						})

						// is a sync required (first time load for user or buddies) 
						if (json.requireSync && to.params.type !== CONSTANTS.TYPE.GROUPS && to.params.name !== 'Sync') {

							next({
								name: 'Sync',
								params: to.params
							})

						} else {

							/*
							if (json.externaldomain && process.env.VUE_APP_ENV === 'production') {

								if (process.env.VUE_APP_TYPE === 'externaldomain') { 

									if(json.externaldomain.value !== externaldomain) {

										window.location.href = 'https://' + json.externaldomain.value

									} else {

										next()

									}

								} else {

									window.location.href = 'https://' + json.externaldomain.value

								}

							} else if (json.subdomain && process.env.VUE_APP_ENV === 'production') {

								if (process.env.VUE_APP_TYPE === 'subdomain') { 

									if(json.subdomain.value !== subdomain) {

										window.location.href = 'https://' + json.subdomain.value + '.geekgroup.app'

									} else {

										next()

									}

								} else {

									window.location.href = 'https://' + json.subdomain.value + '.geekgroup.app'

								}

							} else {
								*/

								if(to.meta.early) {

									if (_.contains(Store.getters['context/early'], to.meta.early)) {

										next()

									} else {

										next({
											name: '404'
										})
										
									}

								} else {

									next()

								}

							//}

						}

					}, function() {

						next({
							name: '404'
						})

					})

				} else {

					next()

				}

			}

		} else {

			next()

		}

	}

}

export default function handler(to, from, next) {

	// eslint-disable-next-line
	ga('set', 'page', to.fullPath)

	// eslint-disable-next-line
	ga('send', 'pageview')

	if (!Store.getters['session/key']) {

		Store.dispatch('api/session/check').then(function() {

			checkStatus(to, from, next)

		}, function() {

			PubSub.$emit('error', CONSTANTS.ERROR.UNKNOWN)

		})

	} else {

		checkStatus(to, from, next)

	}
	
}